import { smartQuoteApiConnector } from 'apiConnector/smart-quote';
import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, ignoreElements, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { handlePromptsFetchedThunk } from 'state/workspaces/smart-quote/thunks';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';
import { workspaceTabsFetchedThunk } from 'state/workspaces/workspace.thunks';

export function fetchSmartQuoteTabsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const api = tabsApiConnector(httpClient, 'smartQuote');
    return action$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'smartQuote'),
      mergeMap(({ tabFetchRequestId }) =>
        api.getAllTabDescriptions().pipe(
          map(({ tabs, activeTabId }) => {
            const actualActiveTabId: string | undefined = activeTabId ?? tabs[0]?.id ?? undefined;
            return workspaceTabsFetchedThunk(tabs, actualActiveTabId, 'smartQuote', tabFetchRequestId);
          }),
          catchError((_: Error) => {
            return of(workspaceTabsFetchFailed('smartQuote', tabFetchRequestId));
          }),
        ),
      ),
    );
  };
}

export function fetchSmartQuotePromptsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const api = smartQuoteApiConnector(httpClient);
    return action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace }) => workspace === 'smartQuote'),
      mergeMap(({ tabId }) =>
        api.fetchPrompts(tabId).pipe(
          map(res => {
            return handlePromptsFetchedThunk(tabId, res);
          }),
          catchError((_: Error) => {
            return of(workspaceTabsFetchFailed('smartQuote'));
          }),
        ),
      ),
    );
  };
}

export function clearSmartQuoteTabContentEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const api = tabsApiConnector(httpClient, 'smartQuote');
    return action$.pipe(
      ofType('WORKSPACE_RESET_TAB_REQUESTED'),
      filter(({ workspace }) => workspace === 'smartQuote'),
      mergeMap(({ tabId }) => api.clearTabContent(tabId).pipe(ignoreElements())),
    );
  };
}
